import { PRODUCTS } from '../../data/products';
import type { Member } from '../../domain/household';
import type { MeatAddOn } from '../../domain/plan';
import { createCatalog, productOf } from '../../domain/price-book';
import { formatQuantity, productName } from '../i18n/format';
import { MESSAGES, type Language } from '../i18n/messages';

/**
 * DE: Fleischbeilage als Text, z. B. „Partner: + Hähnchenbrustfilet 200 g“.
 * EN: Meat add-on as text, e.g. "Partner: + Hähnchenbrustfilet 200 g".
 */
export function addOnText(
  addOn: MeatAddOn,
  members: readonly Member[],
  language: Language,
): string {
  const member = members.find((candidate) => candidate.id === addOn.memberId);
  const product = productOf(createCatalog(PRODUCTS), addOn.productId);
  return MESSAGES[language].addOn(
    member?.name ?? addOn.memberId,
    productName(product, language),
    formatQuantity(addOn.quantity, product.unit, language),
  );
}
